import { getRequest, postRequest, putRequest, deleteRequest } from '../core/apiRequests';
import { clientbookApi } from '../core/clientbook-api';

export const getAppointmentsConfig = async () => {
  return clientbookApi.get({
    url: '/merchants/appointmentsconfig',
    loading: false,
  });
};

export const updateAppointmentsConfig = async (data, loadingStatusOff = true) => {
  return clientbookApi.patch({
    url: '/merchants/appointmentsconfig',
    data,
    loading: !loadingStatusOff,
  });
};

export const getAppointmentTypes = async (loadingStatusOff = true) => {
  const reqObj = {
    params: ['appointments', 'types'],
    loadingStatusOff,
  };

  return getRequest(reqObj);
};

export const createAppointmentType = async (data, loadingStatusOff = true) => {
  const reqObj = {
    params: ['appointments', 'types'],
    data,
    loadingStatusOff,
  };

  return postRequest(reqObj);
};

export const updateAppointmentType = async (typeId, data, loadingStatusOff = true) => {
  const reqObj = {
    params: ['appointments', 'types', typeId],
    data,
    loadingStatusOff,
  };

  return putRequest(reqObj);
};

export const enableAppointment = async (storeId, enable, loadingStatusOff = true) => {
  const reqObj = {
    params: ['appointments', 'stores', storeId],
    data: { enable },
    loadingStatusOff,
  };

  return putRequest(reqObj);
};

export const getStoresAppointmentEnabled = async (loadingStatusOff = true) => {
  const reqObj = {
    params: ['appointments', 'stores'],
    loadingStatusOff,
  };

  return getRequest(reqObj);
};

export const deleteAppointmentType = async typeId => {
  const reqObj = {
    params: ['appointments', 'types', typeId],
  };

  return deleteRequest(reqObj);
};

export const getAppointment = async (appointmentId, loadingStatusOff = true) => {
  return clientbookApi.get({
    url: `/merchants/appointments/${appointmentId}`,
    loading: !loadingStatusOff,
  });
};

export const updateAppointment = async (appointmentId, data, loadingStatusOff = false) => {
  return clientbookApi.patch({
    url: `/merchants/appointments/${appointmentId}`,
    data,
    loading: !loadingStatusOff,
  });
};

export const createAppointment = async ({ clientId, data, loadingStatusOff = false }) => {
  return clientbookApi.post({
    url: `/clients/${clientId}/appointments`,
    data,
    loading: !loadingStatusOff,
  });
};

export const getClientAppointments = async (clientId, query = {}, loadingStatusOff = true) => {
  return clientbookApi.get({
    url: '/merchants/appointments',
    query: {
      clientIds: clientId,
      ...query,
    },
    loading: !loadingStatusOff,
  });
};

export const getMerchantsAppointments = async ({ query = {}, loadingStatusOff = true } = {}) => {
  return clientbookApi.get({
    url: '/merchants/appointments',
    query,
    loading: !loadingStatusOff,
  });
};


export const APPOINTMENTS_STATUS = {
  REQUESTED: 'REQUESTED',
  ASSIGNED: 'ASSIGNED',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
  NO_SHOW: 'NO_SHOW',
};

export const APPOINTMENTS_MESSAGES = [
  {
    id: 'confirmation',
    name: 'New Appointment',
    timing: 'Immediately',
    title: 'New Appointment Message',
    defaultMessage:
      'Hello :name:, your appointment is confirmed for :appointment_date: at :appointment_time: at :merchant_name:. :associate: looks forward to welcoming you.',
  },
  {
    id: 'updated',
    name: 'Updated Appointment',
    timing: 'Immediately',
    title: 'Updated Appointment Message',
    defaultMessage:
      'Hello :name:, your appointment has been updated to :appointment_date: at :appointment_time: at :merchant_name:. :associate: looks forward to welcoming you.',
  },
  {
    id: 'reminder',
    name: 'Appointment Reminder',
    timing: '1 day before',
    title: 'Appointment Reminder Message',
    defaultMessage:
      'Your visit is on :appointment_date:, at :appointment_time: at :merchant_name:. Let us know if you have any questions!',
  },
  {
    id: 'noShow',
    name: 'No Show',
    timing: '1 day after',
    title: 'No Show Appointment Message',
    defaultMessage:
      'We missed you at your appointment :appointment_date: at :appointment_time:, and would love to have you in at another time. Schedule a time here! :kiosk_link:.',
  },
  {
    id: 'canceled',
    name: 'Canceled Appointment',
    timing: 'Immediately',
    title: 'Canceled Appointment Message',
    defaultMessage:
      'Your appointment on :appointment_date: at :appointment_time: has been canceled. We’d love to have you in another time that works for you. :kiosk_link:',
  },
];
